// The page an old /visual-tool/ link lands on (visual-tool-handoff.blade.php,
// VisualToolController::handoff()). It opens the new Visual Mode the way an in-app Visual
// Mode button does: it calls the same store method, openFromButton(), so the extension
// check, the extension-visual-mode flag, the install prompt and the bridge to the extension
// are the ones every other button uses. It only waits for detection to settle first,
// because nothing was clicked: before that, "not detected yet" and "not installed" look the
// same.
//
// The old screen's URL (?classic=1) is the app URL the store falls back to when the flag is
// off, exactly as an in-app button falls back to it. That one arm is taken here with
// location.replace() instead of the store's location.assign(): with the flag off, an
// ordinary in-app Visual Mode click lands on this page too, and assign() left this page in
// history, so Back from the old screen reloaded it and was sent forward again.
//
// A page reached with Back or Forward does not act on its own. The user is retracing their
// steps: acting again would open a second Visual Mode tab, or bounce them back to the old
// screen. The button still works.
//
// A page opened in a background tab (a Cmd-click on the plugin's list) waits until it is
// shown. The extension opens Visual Mode as the active tab, so acting from a hidden tab would
// pull the user away from where they were, once per link.
//
// open() is the decision, whether the page or the user calls it, so a click before detection
// settles is not followed by a second open when it does. The status line says what open()
// did, not what the store says now: an extension that turns up after the install prompt
// opened has not opened anything yet.
//
// `browser` is the window. visual-tool-handoff.test.js passes a stand-in, so
// `npm run test:js` can run this without one.
export default (classicUrl, liveUrl, targetInstance, messages, browser = window) => ({
    decided: false,
    waitingToBeSeen: false,
    outcome: null,

    init() {
        this.$watch('$store.browserExtensionState.enabled', () => this.decide());
        this.$watch('$store.browserExtensionState.detectionSettled', () => this.decide());
        this.decide();
    },

    open() {
        this.decided = true;
        const store = this.$store.browserExtensionState;
        store.detectFromMarker();
        if (store.enabled && !store.extensionRefactorEnabled) {
            this.outcome = 'classic';
            browser.location.replace(classicUrl);
            return;
        }
        this.outcome = store.enabled ? 'opened' : 'install';
        store.openFromButton(classicUrl, liveUrl, targetInstance, this.$refs.open);
    },

    decide() {
        const store = this.$store.browserExtensionState;
        if (this.decided || (!store.enabled && !store.detectionSettled)) {
            return;
        }
        if (browser.document.visibilityState !== 'visible') {
            if (!this.waitingToBeSeen) {
                this.waitingToBeSeen = true;
                browser.document.addEventListener('visibilitychange', () => this.decide());
            }
            return;
        }
        this.decided = true;
        if (browser.performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
            return;
        }
        this.open();
    },

    get message() {
        if (!this.decided) {
            return messages.checking;
        }
        if (this.outcome === null) {
            return '';
        }
        if (this.outcome === 'install') {
            return this.$store.browserExtensionState.enabled ? messages.installed : messages.install;
        }
        return this.outcome === 'opened' ? messages.opened : messages.classic;
    },
});
